module.exports = __webpack_public_path__ + "img/symbol_1.e20bd12a.png";